import React, { useCallback } from 'react'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import { SearchInput, useAction, useHelmet } from '@agro-club/frontend-shared'
import ContactLifeCycleList from './ContactLifeCycleList/ContactLifeCycleList'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import ContactLifeCycleActions from 'modules/domain/contactLifeCycle/duck'
import ContactLifeCycleSelectors from 'modules/domain/contactLifeCycle/selectors'
import { useSelector } from 'react-redux'

const SearchInputWrapper = styled.div`
  margin-top: 14px;
  margin-bottom: 4px;
  width: 50%;
`

const ContactLifeCycleTable = () => {
  const filter = useSelector(ContactLifeCycleSelectors.filter)
  const filterUpdated = useAction(ContactLifeCycleActions.filterUpdated)
  const { t } = useTranslation('contactLifeCycle')

  const handleSearchChange = useCallback(
    (search?: string) => {
      filterUpdated({ ...filter, ...{ search } })
    },
    [filterUpdated, filter],
  )

  useHelmet({ title: t('contactLifeCycleMetaTitle') })

  return (
    <>
      <Layout.Header>
        <Header.Root>
          <Header.Title title={t('list.heading')}></Header.Title>
          <SearchInputWrapper>
            <SearchInput
              onChange={handleSearchChange}
              value={filter.search}
              placeholder={t('list.searchPlaceholder')}
            />
          </SearchInputWrapper>
        </Header.Root>
      </Layout.Header>
      <Layout.Content>
        <ContactLifeCycleList />
      </Layout.Content>
    </>
  )
}

export default ContactLifeCycleTable
